'use client'

import {observer} from 'mobx-react'
import React from 'react'

import * as UI from '@/src/features/catalog/filters-v2/ui/filters.styled'

import Button from '@/src/shared/ui/button'

import {
  useCatalogFiltersVisibility,
  useFilters,
} from '@/src/features/catalog/filters-v2/containers/csr-filters-provider'

export const CatalogFiltersMobileBtn = observer(({className}: {className?: string}) => {
  const store = useCatalogFiltersVisibility()!
  const filtersStore = useFilters()
  const counter = filtersStore.selectedCount

  return (
    <UI.CatalogFiltersMobileBtn className={className} as={Button} onClick={store?.toggle}>
      Фильтры {counter > 0 && `(${counter})`}
    </UI.CatalogFiltersMobileBtn>
  )
})
